import React, {FC} from "react";
import ChatMessage from "./ChatMessage";
import JoinMessage from "./JoinMessage";
import LeaveMessage from "./LeaveMessage";
import {Message} from "../../lib/stores/MessageStore";
import {MessageType} from "../../lib/interfaces";

interface MessageComponentProps {
    message: Message; // This should be replaced with the actual type of `message`
}

const MessageComponent: FC<MessageComponentProps> = ({message}) => {
    switch (message.type) {
        case MessageType.Default:
            return <ChatMessage message={message}/>;
        case MessageType.UserJoin:
            return <JoinMessage message={message}/>;
        case MessageType.UserLeave:
            return <LeaveMessage message={message}/>;
        default:
            return <ChatMessage message={message}/>;
    }
}

export default MessageComponent;
